import React, { Component } from 'react';

class widgetSearch extends Component{
	render(){
		return(
			<>
				<div className="widget widget_search bg-black">
					<form className="searchform">
						<div className="input-group">
							<input name="text" className="form-control" placeholder="Introduceți cuvintele ..." type="text"/>
							<div className="input-group-btn bg-black">
								<button type="submit" className="btn btn-secondary"><i className="fa fa-search"></i></button>
							</div> 
						</div>
					</form>
				</div>
				
			</>
		);
	}
}

export default widgetSearch;